import { useQuery } from "@tanstack/react-query";
import { GetContractsRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useGetContracts = (tempWorkerId: number, props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['temp_workers', `${tempWorkerId}`, 'contracts'], () => GetContractsRequest(tempWorkerId), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

export { useGetContracts };